export default {
  "activities.title": "Activités & Programmes",
  "activities.subtitle": "Une offre complète pour tous les niveaux et tous les âges",
  "activities.tab1": "Cours Adultes",
  "activities.tab2": "Enfants & Ados",
  "activities.tab3": "Kid Summer Camp",
  "activities.tab4": "Formation Coaches",
  "activities.tab5": "Compétitions ITF",
  "activities.tab6": "Location de Courts",
  "activities.adults.title": "Cours Adultes",
  "activities.adults.desc": "Des programmes adaptés à votre niveau, du débutant au compétiteur chevronné. Nos coachs certifiés vous accompagnent dans votre progression.",
  "activities.adults.item1": "Cours débutants — Apprenez les fondamentaux",
  "activities.adults.item2": "Cours amateurs — Perfectionnez votre technique",
  "activities.adults.item3": "Cours compétiteurs — Préparez vos tournois",
  "activities.adults.item4": "Sparring & Matchs — Jouez avec des partenaires de niveau",
  "activities.kids.title": "Enfants & Adolescents (5–16 ans)",
  "activities.kids.desc": "École de tennis pour les jeunes talents. Développement technique, tactique et mental dans un cadre ludique et stimulant.",
  "activities.kids.item1": "Mini Tennis (5–8 ans) — Coordination et premiers échanges",
  "activities.kids.item2": "Junior (9–12 ans) — Technique et premiers matchs",
  "activities.kids.item3": "Performance (13–16 ans) — Préparation compétition",
  "activities.kids.item4": "Stages vacances — Formules intensives pendant les congés",
  "activities.camp.title": "Kid Summer Camp 2026",
  "activities.camp.desc": "Le programme estival incontournable pour les jeunes de 5 à 16 ans. Deux sessions au choix avec des activités variées alliant sport, technologie et développement personnel.",
  "activities.camp.session1": "Session 1 : 8 juin – 3 juillet 2026",
  "activities.camp.session2": "Session 2 : 6 juillet – 31 août 2026",
  "activities.camp.schedule": "Lundi – Vendredi, 9h00 – 15h00",
  "activities.camp.activity1": "Tennis quotidien avec coachs certifiés",
  "activities.camp.activity2": "Ateliers tactiques & mentaux",
  "activities.camp.activity3": "Développement personnel",
  "activities.camp.activity4": "Initiation à l'IA et technologie",
  "activities.camp.activity5": "Yoga, Pilates et mobilité",
  "activities.camp.activity6": "Mini-foot, ping-pong, mini-basket, trampoline",
  "activities.camp.cta": "Inscrire mon enfant",
  "activities.coaching.title": "Formation Coaching International",
  "activities.coaching.desc": "Programme de 4 jours intensifs pour former la nouvelle génération de coachs africains. Formation certifiée par Coach Boutoto Rapontchombo, diplômé international.",
  "activities.coaching.item1": "Techniques modernes de coaching",
  "activities.coaching.item2": "Préparation mentale des athlètes",
  "activities.coaching.item3": "Encadrement professionnel",
  "activities.coaching.item4": "Leadership sportif et gestion d'équipe",
  "activities.coaching.cta": "En savoir plus",
  "activities.itf.title": "Compétitions & Tournois ITF",
  "activities.itf.desc": "Le TCD accueille des tournois internationaux ITF J30, attirant les meilleurs jeunes joueurs du monde entier. Une opportunité unique de briller sur la scène internationale.",
  "activities.itf.item1": "Tournois ITF J30 — 30 points au classement mondial",
  "activities.itf.item2": "Catégories : Simple Messieurs, Simple Dames, Double",
  "activities.itf.item3": "Compétitions interclubs régulières",
  "activities.itf.item4": "Sparring de haut niveau disponible",
  "activities.itf.cta": "Voir le calendrier",
  "activities.rental.title": "Location de Courts",
  "activities.rental.desc": "Réservez votre court en quelques secondes via notre application mobile. Disponible 7j/7 de 6h à 22h.",
  "activities.rental.item1": "Réservation instantanée via l'app mobile",
  "activities.rental.item2": "6 courts disponibles (central, standards, training)",
  "activities.rental.item3": "Éclairage nocturne sur tous les courts",
  "activities.rental.item4": "Équipements disponibles à la location",
  "activities.rental.cta": "Télécharger l'App"
}